<template>
    <div>
        <GmapMap
            ref="mapRef"
            :zoom="16"
            :center="{lat: latitude, lng: longitude}"
            style='width:100%;  height: 500px;'
            map-type-id="terrain"
            :options="{
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: true,
                rotateControl: true,
                fullscreenControl: true,
                disableDefaultUi: false
            }"
        >
            <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="false"
                @click="openInfoWindow(m); "
            />
            <GmapInfoWindow
                :position="{ lat: latitude, lng: longitude }"
                :opened="infoBoxOpen"
                @closeclick="infoBoxOpen = false;"
            >
                <div class="infoWindow">
                    <div class="card p-0">
                        <div class="card-body p-1">
                            <h6 class="m-0 p-0">{{ stationdescription.UnitName }}</h6>
                            <div>{{ stationdescription.Id }}<br>{{ stationdescription.Address }}</div>
                            <br>
                            <el-button type="danger" size="mini" @click="closeInfoWindow();">Close</el-button>
                        </div>
                    </div>
                </div>
            </GmapInfoWindow>
        </GmapMap>
        <!--
        <div id="map2" ref="map2" style="height: 400px; width: 100%;"></div>
        <div style="width: 100%">
            <iframe width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" 
                    src="https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=-6.242501,106.852474">
                    
            </iframe>
        </div>

        <iframe width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                src="https://www.google.com/maps/embed/v1/view?key=AIzaSyB8XaZbFYykQlXT36z4tINM_7jyJDmhvhI&center=-6.242501,106.852474&zoom=14&maptype=satellite">
        </iframe>
        -->
    </div>
</template>

<script>
export default
{
    //extends: Component,
    components: {

    },
    props: {
        stationdetail: {
            type: Object,
            default: () => ({}), 
        },
        location: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            latitude: -6.177531921860371,
            longitude: 106.83167662845935,

            stationdescription: {
                Id: '-',
                UnitName: '',
                Address: '',
            },

            markers: [],
            infoBoxOpen : false,
            pov: null,
            pano: null,
            mapposition: { lat: -6.177531921860371, lng: 106.83167662845935 },
        }
    },
    watch: {
        location() {
            this.stationdescription = this.stationdetail;

            this.latitude = this.location.lat;
            this.longitude = this.location.lng;

            this.addMarker();
        },
    },
    mounted() {
        
    },
    methods: {
        
        //Maps
        addMarker() {
            //if (this.currentPlace) {
                const marker = {
                    lat: this.latitude, // this.currentPlace.geometry.location.lat(),
                    lng: this.longitude, // this.currentPlace.geometry.location.lng(),
                };

                this.markers.push({ position: marker });
                //this.places.push(this.currentPlace);
                this.center = marker;
                //this.currentPlace = null;
            //}
        },
        openInfoWindow(location) {
			//this.selectedLocation = location;
			this.infoBoxOpen = true;
		},
		closeInfoWindow() {
			this.infoBoxOpen = false;
		},
        showStreetView() {

        },
        updatePov(pov) {
            this.pov = pov;
        },
        updatePano(pano) {
            this.pano = pano;
        },

        //UNUSED BELOW
        loadGoogleMaps() {
            this.$refs.mapRef.$mapPromise.then((map) => {
                map.panTo({lat: -6.242501, lng: 106.852474})
                
                /*
                map.getStreetView().setOptions({
                    addressControlOptions: {
                        position: {lat: -6.242501, lng: 106.852474}, //google.maps.ControlPosition.RIGHT_BOTTOM
                    }
                });
                */
 
                //map.setZoom(map.getZoom() + 2);

                //let panorama = map.getStreetView();
                //map.setStreetView(panorama); 
                
                //console.log('set panoramic ');

                // Initialize Street View   
                /*           
                let panorama = new this.$google.maps.StreetViewPanorama(
                    document.getElementById('map2'),
                    {
                    position: { lat: -6.242501, lng: 106.852474 },
                    pov: {
                        heading: 34,
                        pitch: 10,
                    },
                    visible: true,
                    }
                );

                // Link the Street View panorama to the map
                map.setStreetView(panorama);
                */
                             
                // Optional: log to console for debugging
                //console.log('Street View set to coordinates:', panorama.getPosition().toString());
            });
        },

        //StreetView Sample StandAlone
        loadGoogleMapsStandAlone() {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyB8XaZbFYykQlXT36z4tINM_7jyJDmhvhI&callback=initMap`;
            script.async = true;
            script.defer = true;
            window.initMap = this.initMap;
            document.head.appendChild(script);
        },

        initMap() {
            // Coordinate Location Street View (latitude dan longitude)
            const location = { lat: -6.242501, lng: 106.852474 };

            // Map init
            const map = new this.$google.maps.Map(this.$refs.map2, {
                center: location,
                zoom: 14,
            });

            // Init Street View
            //const panorama = new google.maps.StreetViewPanorama(this.$refs.map, {
            const panorama = new this.$google.maps.StreetViewPanorama(this.$refs.map2, {
                position: location,
                pov: {
                heading: 34,
                pitch: 10,
                },
            });

            // Set Street View on peta
            map.setStreetView(panorama);
        },
        //End StreetView
    }
}
</script>
